import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { BaseService } from "@/script/core/service/BaseService";
import { CallBack, Failure, Success } from "@/script/core/service/DataService";
import { Inspect } from "../entity/InspectEntity";

class InspectService extends BaseService {
  public action(
    api: string,
    inspect: Inspect,
    success: Success,
    failure?: Failure
  ) {
    super.post(api, inspect).then(
      function (result) {
        success(result);
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  } 
}

let inspectContext: ServiceContext | null = null;
function createInspectContext(): ServiceContext {
  if (inspectContext == null) {
    const service = new InspectService();
    inspectContext = ServiceFactory.build(
      "biz_ins_inspect",
      "/ins/inspect",
      "/ins/inspect",
      service
    );
  }
  return inspectContext;
}

export { InspectService, inspectContext, createInspectContext };
